export const RouterFilters = {
  AVAILABILITY_TYPE: 'availabilityType',
  AREA_OF_CONCERN: 'areaOfConcern',
  GENDER: 'gender',
  CLIENT_AGE_GROUP: 'clientAgeGroup',
  LANGUAGE: 'language',
  COUNSELING_APPROACH: 'counselingApproach',
  COUNSELING_TYPE: 'counselingType',
  LOCATION: 'location',
  STATE: 'state',
} as const

export const GroupedFiltersMapping = {
  [RouterFilters.AVAILABILITY_TYPE]: 'availability_type',
  [RouterFilters.AREA_OF_CONCERN]: 'area_of_concern',
  [RouterFilters.GENDER]: 'gender',
  [RouterFilters.CLIENT_AGE_GROUP]: 'client_age_group',
  [RouterFilters.LANGUAGE]: 'language',
  [RouterFilters.COUNSELING_APPROACH]: 'counseling_approach',
  [RouterFilters.COUNSELING_TYPE]: 'counseling_type',
} as const

export const leadGenFilterKeyMapping = {
  LEAD_GEN_TYPE: 'Lead_Gen_Type__c',
  [RouterFilters.AVAILABILITY_TYPE]: 'Visit_type__c',
  [RouterFilters.AREA_OF_CONCERN]: 'Specialtypreference_patientlead__c',
  [RouterFilters.GENDER]: 'Clinician_Gender__c',
  [RouterFilters.CLIENT_AGE_GROUP]: 'Client_Age__c',
  [RouterFilters.LANGUAGE]: 'Language_Preference__c',
  [RouterFilters.COUNSELING_APPROACH]: 'Counseling_approach__c',
  [RouterFilters.COUNSELING_TYPE]: 'Service_type__c',
  [RouterFilters.LOCATION]: 'City',
  [RouterFilters.STATE]: 'State',
  USER_GENDER: 'User_Gender__c',
} as const

export enum LeadGenScenarios {
  SEARCH_NO_SUPPLY = 'search_no_supply',
  SEARCH_LOW_SUPPLY = 'search_low_supply',
  SEARCH_NO_SUPPLY_WATERFALL = 'search_no_supply_waterfall',
  SEARCH_NO_SUPPLY_WATERFALL_INSURANCE = 'search_no_supply_waterfall_insurance',
  PROFILE_NO_SUPPLY = 'profile_no_supply',
  PROFILE_LOW_SUPPLY = 'profile_low_supply',
}

export type ForwardingFilters = Record<string, string | number | string[]>
